import {useState} from 'react'
import {Content} from '../../../../_metronic/layout/components/content'
import RoleList from './RoleList'
import {Role} from './_model'
import {KTIcon} from '../../../../_metronic/helpers'
import AssignPermissionForm from '../role-management/modal/AssignPermissionForm'
import useUserRole from '../../../hooks/useUserRole'
import ViewAssignedRoleDetails from './modal/ViewAssignedRoleDetails'
import RoleForm from './modal/RoleForm'
import InputSearchBox from '../../../utils/components/form/InputSearchBox'

const UserRole = () => {
  const {roles, refetch} = useUserRole()
  const [selectedRole, setSelectedRole] = useState<Role | null>(null)
  const [updateRole, setUpdateRole] = useState<Role | null>(null)
  const [viewDetailsRole, setViewDetailsRole] = useState<Role | null>(null)
  const [searchTerm, setSearchTerm] = useState('')

  const handleSelectRole = (type: string, role: Role) => {
    switch (type) {
      case 'edit':
        setSelectedRole(role)
        break
      case 'roleEdit':
        setUpdateRole(role)
        break
      case 'view':
        setViewDetailsRole(role)
        break

      default:
        break
    }
  }

  const onResetSelected = () => {
    setSelectedRole(null)
    setUpdateRole(null)
    setViewDetailsRole(null)
  }

  return (
    <Content>
      <div className='d-flex justify-content-between align-items-center gap-4 flex-wrap mb-6'>
        <InputSearchBox searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        <div>
          <button
            type='button'
            className='btn btn-success me-4'
            data-bs-toggle='modal'
            data-bs-target='#kt_modal_4'
            onClick={onResetSelected}
          >
            <KTIcon iconName='plus' className='fs-2' />
            Add New Role
          </button>

          <button
            type='button'
            className='btn btn-primary'
            data-bs-toggle='modal'
            data-bs-target='#kt_modal_1'
            onClick={onResetSelected}
          >
            <KTIcon iconName='plus' className='fs-2' />
            Assign/Permission
          </button>
        </div>

        <AssignPermissionForm selectedRole={selectedRole} roles={roles} />
      </div>
      <RoleForm selectedRole={updateRole} refetch={refetch} onReset={onResetSelected} />
      <RoleList handleSelectRole={handleSelectRole} searchTerm={searchTerm} />
      <ViewAssignedRoleDetails selectedRole={viewDetailsRole} onResetSelected={onResetSelected} />
    </Content>
  )
}

export default UserRole
